import { Component, Input, OnInit } from '@angular/core';
import { BasicMsisdn } from './msisdns';
import { getFlagClass } from '../utils/flag-class';

@Component({
  selector: 'cc-msisdn',
  templateUrl: './msisdn.component.html',
  styleUrls: ['./msisdn.component.scss']
})
export class MsisdnComponent implements OnInit {
  @Input() msisdn: BasicMsisdn;
  @Input() small: boolean;
  public getFlagClass = getFlagClass;

  constructor() {}

  ngOnInit() {}
}
